import SecondaryPagesImage from '../../components/SecondaryPagesImage';
import SecondaryPagesBanner from '../../components/SecondaryPagesBanner';
import ourTeam from '../../images/our-team.jpeg';
import { Trans, withTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import history from '../../images/history.jpeg';
import news from '../../images/news.jpeg';
import vacancies from '../../images/vacancies.jpeg';


function MessageFromHT() {
    let { pathname } = useLocation();

    pathname = pathname.replace('/about-us/', '')

    const MAIN_BLOCK_DATA = {
       'message-from': {
          header: `message from`,
          image: ourTeam,
          text: `welcome to`,
          // This page draws its own header (video + text), so skip the shared image and banner
          hideBanner: true
       },
       'our-history': {
        header: `our history`,
        image: history,
        text: `established in london`
       },
       'our-team': {
        header: 'passionate team',
        image: ourTeam,
        text: 'people who make our school'
       },
       'st-marys-in-media-and-news': {
        header: 'Media and News',
        image: news,
        text: '',
        // This page draws its own header, so skip the shared image and banner
        hideBanner: true
       },
       'vacancies': {
        header: 'Vacancies',
        image: vacancies,
        text: 'introduces current vacancies'
       },
       'annual-reports': {
        header: 'Annual Reports',
        image: history,
        text: ''
       },
       'st-marys-in-media-and-news/breaking-news': {
        // Hidden page: draws its own header
        hideBanner: true
       },
       'child-story': {
        header: `temp news header`,
        text: `temp news subheader`
       }
    };

    const pageData = MAIN_BLOCK_DATA[pathname];

    return(
      <>
        {!pageData.hideBanner && (
          <>
            <SecondaryPagesImage image={pageData.image} />
            <SecondaryPagesBanner header={<Trans i18nKey={pageData.header}/>}
            text={<Trans i18nKey={pageData.text}/>}/>
          </>
        )}
        <Outlet />
      </>
    );
}

export default withTranslation()(MessageFromHT);